module.exports = __webpack_public_path__ + "img/seckill_bg.36405fbc.png";